<template>
  <div id="a1">
    About a1 page.
  </div>
</template>

<script>
  export default {
    name: 'a1',
    //  页面加载之前
    created () {
    },
    //  页面加载后
    mounted () {
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/modules/about/a1/a1.vue